import { __decorate } from "tslib";
import { navigateToRoot } from "@/Helpers/NavigationHelpers";
import { Component, Vue } from "vue-property-decorator";
import { Action, Getter, Mutation, State } from "vuex-class";
import { required, helpers } from 'vuelidate/lib/validators';
const mustContainAtSymbol = (value) => value?.includes('@') === true;
const usernameRegex = helpers.regex('value', /(.+)@(.+){1,}/);
let LoginForm = class LoginForm extends Vue {
    userName;
    IsAuthenticated;
    setUserName;
    isLoadingData;
    loginEvent;
    password = "";
    localMessages = {
        mustContainAtSymbol: 'validation.username-must-contain-at',
        usernameValidation: 'validation.username-missing-domain'
    };
    get userNameValue() {
        return this.userName;
    }
    set userNameValue(value) {
        this.setUserName(value);
        this.$v.userNameValue?.$touch();
    }
    async login() {
        this.$v.$touch();
        if (this.$v.$invalid)
            return;
        await this.loginEvent({ UserName: this.userNameValue, Password: this.password });
        if (this.IsAuthenticated) {
            navigateToRoot();
        }
    }
    get version() {
        return `${process.env.VUE_APP_NAME} - V${process.env.VUE_APP_VERSION}`;
    }
};
__decorate([
    State
], LoginForm.prototype, "userName", void 0);
__decorate([
    Getter
], LoginForm.prototype, "IsAuthenticated", void 0);
__decorate([
    Mutation
], LoginForm.prototype, "setUserName", void 0);
__decorate([
    State
], LoginForm.prototype, "isLoadingData", void 0);
__decorate([
    Action("login")
], LoginForm.prototype, "loginEvent", void 0);
LoginForm = __decorate([
    Component({
        components: {},
        validations: {
            userNameValue: {
                required,
                mustContainAtSymbol,
                usernameValidation: usernameRegex
            },
            password: {}
        }
    })
], LoginForm);
export default LoginForm;
